<script>
import appConfig from "@/app.config";
import { integer } from "@vuelidate/validators";
import $ from "jquery";

export default {
  page: {
    title: "Dashboard",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  computed: {
    shuffledJawaban() {
      // Shuffle the array of jawaban
      return this.shuffleArray(this.list.jawaban);
    },
  },
  components: {},
  data() {
    return {
      link: process.env.VUE_APP_BACKEND_URL,
    };
  },
  props: {
    list: [],
    nomorUrut: integer,
    currentPage: integer,
    selectAnswer: Function,
  },
  emits: ["showImage"],
  mounted() {
    const self = this;
    $(".pilihan-jawaban img")
      .addClass("image-soal")
      .css("height", "100px")
      .wrap("<div class='container-image-soal'></div");
    // $(".image-soal").after(
    //   `<div
    //     class="middle d-flex flex-column gap-2 align-items-center justify-content-center"
    //   >
    //     <button
    //       class="btn btn-success btn-sm preview-btn"
    //     >
    //       <i class="fa fa-search"></i> Preview
    //     </button>
    //   </div>`
    // );

    $(".image-soal").click(function () {
      self.previewImage = true;
      self.urlSrc = $(this).attr("src");
      self.$emit("showImage", $(this).attr("src"));
    });
  },
  methods: {
    shuffleArray(array) {
      let currentIndex = array.length,
        temporaryValue,
        randomIndex;

      while (0 !== currentIndex) {
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;

        temporaryValue = array[currentIndex];
        array[currentIndex] = array[randomIndex];
        array[randomIndex] = temporaryValue;

        // Simpan indeks jawaban yang benar jika ditemukan
        if (temporaryValue.jawaban_benar) {
          this.indexOfCorrectAnswer = randomIndex;
        }
      }

      return array;
    },
    selectAnswerFunction(list, jawaban) {
      if (typeof this.selectAnswer === "function") {
        this.selectAnswer(list, jawaban);
      }
    },
    preview(url) {
      this.$emit("showImage", url);
    },
  },
};
</script>

<template>
  <div class="w-100 text-center">
    <div
      class="container-image"
      style="width: 30%; margin: auto"
      v-if="list.soal_image"
    >
      <img v-if="list.soal_image" :src="link + list.soal_image" class="image" />
      <div
        class="middle d-flex flex-column gap-2 align-items-center justify-content-center"
      >
        <button
          class="btn btn-success btn-sm"
          @click="preview(link + list.soal_image)"
        >
          <i class="fa fa-search"></i> Preview
        </button>
      </div>
    </div>
  </div>
  <div v-if="list.soal_text !== null" class="card mb-2">
    <div class="card-body bg-light" style="border-radius: 5px">
      {{ list.soal_text }}
    </div>
  </div>
  <!-- <div class="soal mt-3 px-3">{{ nomorUrut }}. {{ list.pertanyaan }}</div> -->
  <table class="soal mt-3 px-3">
    <tr>
      <td style="vertical-align: top;">{{ nomorUrut }}</td>
      <td style="vertical-align: top;"> . </td>
      <td>
        <div v-html="list.pertanyaan"></div>
      </td>
    </tr>
  </table>
  <div class="pilihan-ganda row mx-4">
    <!-- <div
      class="col-md-6"
      v-for="jawaban in list.jawaban"
      :key="jawaban.idjawaban"
    >
      <div class="d-flex">
        <button
          class="mt-3 btn btn-block flex-grow-1"
          :class="[jawaban.selected ? 'btn-primary' : 'btn-secondary']"
          @click="selectAnswerFunction(list, jawaban)"
        >
          {{ jawaban.jawaban }}
        </button>
      </div>
    </div> -->

    <div
      class="col-md-6 mt-5"
      v-for="jawaban in list.jawaban"
      :key="jawaban.idjawaban"
    >
      <div
        class="d-flex justify-content-center align-items-center pilihan-jawaban"
        :class="[jawaban.selected ? 'bg-primary' : 'bg-secondary']"
        @click="selectAnswerFunction(list, jawaban)"
      >
        <div v-html="jawaban.jawaban"></div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.border-none {
  border-style: hidden;
}

.selected {
  background-color: #00f;
  /* Change the background color for selected buttons */
  color: #fff;
  /* Change the text color for selected buttons */
}
.pilihan-jawaban {
  height: 150px;
  color: #fff;
  text-align: center;
}
</style>

